// General
import { createSlice } from "@reduxjs/toolkit";
// Static Data
import searchConst from "../../const/searchConst";

const initialState = {
  // Main Page variables
  filteredLists: [],
  recentlyActiveLists: [],
  lgbtqRecentlyActiveLists: [],
  nearbyLists: [],
  newestLists: [],
  collegeLists: [],
  premiumLists: [],
  masqueradePartyLists: [],

  // Pagination variables
  filteredPage: 1,
  filteredPagination: null,
  recentlyActivePagination: null,
  lgbtqRecentlyActivePagination: null,
  nearbyPagination: null,
  newestPagination: null,
  collegePagination: null,
  premiumPagination: null,
  masqueradePartyPagination: null,

  // TOR variables
  torList: [],
  selectedTorAfterApply: [],

  // General variables
  selectedCategoryTab: "recently_active",
  selectedView: searchConst.userCardDisplay.grid, // list, grid

  // Utility variables
  setCurrentLocationPassthrough: null,

  // API Param & Body variables
  searchParam: {
    sort_by: "",
  },
  searchBody: {
    size: 16,
    location: {
      lat: null,
      lng: null,
      country: null,
      country_iso: null,
      city: null,
      state: null,
    },
    sorting: "", // nearest, newest, college, featured, recently_active
    filters: {
      search_term: null,
      premium_only: null,
      photos: null,
      viewed: null,
      unviewed: null,
      favorited: null,
      favorited_me: null,
      age: {
        min: searchConst.filters.ageRange.min,
        max: searchConst.filters.ageRange.max,
      },
      // height: {
      //   min: searchConst.filters.heightRange.min,
      //   max: searchConst.filters.heightRange.max,
      // },
      children: null,
      ethnicity: null,
      tor: null,
      lifestyle: null,
      relationship: null,
      body_type: null,
      drinking: null,
      smoking: null,
      education: null,
      eye_color: null,
      hair_color: null,
    },
  },

  // Scroll variables
  scrollYPosition: 0,
  searchScrollToTopPassthrough: {},

  // Utility variables
  restartJourneyCounter: 0,
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    // Main Page Functions
    updateFilteredLists: (state, action) => {
      const filteredListsData = [
        ...state.filteredLists,
        ...action.payload.filter((item) => {
          if (item.type === "user") {
            return !state.filteredLists.some((list) => {
              if (list.type === "user") {
                return list.user.id_int === item.user.id_int;
              } else {
                return false;
              }
            });
          } else {
            return true;
          }
        }),
      ];
      state.filteredLists = filteredListsData;
    },
    updateRecentlyActiveLists: (state, action) => {
      const recentlyActiveListsData = [
        ...state.recentlyActiveLists,
        ...action.payload.filter((item) => {
          if (item.type === "user") {
            return !state.recentlyActiveLists.some((list) => {
              if (list.type === "user") {
                return list.user.id_int === item.user.id_int;
              } else {
                return false;
              }
            });
          } else {
            return true;
          }
        }),
      ];
      state.recentlyActiveLists = recentlyActiveListsData;
    },
    updateLgbtqRecentlyActiveLists: (state, action) => {
      const lgbtqRecentlyActiveListsData = [
        ...state.lgbtqRecentlyActiveLists,
        ...action.payload.filter((item) => {
          if (item.type === "user") {
            return !state.lgbtqRecentlyActiveLists.some((list) => {
              if (list.type === "user") {
                return list.user.id_int === item.user.id_int;
              } else {
                return false;
              }
            });
          } else {
            return true;
          }
        }),
      ];
      state.lgbtqRecentlyActiveLists = lgbtqRecentlyActiveListsData;
    },
    updateNearbyLists: (state, action) => {
      const nearbyListsData = [
        ...state.nearbyLists,
        ...action.payload.filter((item) => {
          if (item.type === "user") {
            return !state.nearbyLists.some((list) => {
              if (list.type === "user") {
                return list.user.id_int === item.user.id_int;
              } else {
                return false;
              }
            });
          } else {
            return true;
          }
        }),
      ];
      state.nearbyLists = nearbyListsData;
    },
    updateNewestLists: (state, action) => {
      const newestListsData = [
        ...state.newestLists,
        ...action.payload.filter((item) => {
          if (item.type === "user") {
            return !state.newestLists.some((list) => {
              if (list.type === "user") {
                return list.user.id_int === item.user.id_int;
              } else {
                return false;
              }
            });
          } else {
            return true;
          }
        }),
      ];
      state.newestLists = newestListsData;
    },
    updateCollegeLists: (state, action) => {
      const collegeListsData = [
        ...state.collegeLists,
        ...action.payload.filter((item) => {
          if (item.type === "user") {
            return !state.collegeLists.some((list) => {
              if (list.type === "user") {
                return list.user.id_int === item.user.id_int;
              } else {
                return false;
              }
            });
          } else {
            return true;
          }
        }),
      ];
      state.collegeLists = collegeListsData;
    },
    updatePremiumLists: (state, action) => {
      const premiumListsData = [
        ...state.premiumLists,
        ...action.payload.filter((item) => {
          if (item.type === "user") {
            return !state.premiumLists.some((list) => {
              if (list.type === "user") {
                return list.user.id_int === item.user.id_int;
              } else {
                return false;
              }
            });
          } else {
            return true;
          }
        }),
      ];
      state.premiumLists = premiumListsData;
    },
    updateMasqueradePartyLists: (state, action) => {
      const masqueradePartyListsData = [
        ...state.masqueradePartyLists,
        ...action.payload.filter((item) => {
          if (item.type === "user") {
            return !state.masqueradePartyLists.some((list) => {
              if (list.type === "user") {
                return list.user.id_int === item.user.id_int;
              } else {
                return false;
              }
            });
          } else {
            return true;
          }
        }),
      ];
      state.masqueradePartyLists = masqueradePartyListsData;
    },
    resetDatingSearchLists: (state) => {
      state.datingSearchLists = [];
    },
    resetFilteredLists: (state) => {
      state.filteredLists = [];
    },
    resetRecentlyActiveLists: (state) => {
      state.recentlyActiveLists = [];
    },
    resetLgbtqRecentlyActiveLists: (state) => {
      state.lgbtqRecentlyActiveLists = [];
    },
    resetNearbyLists: (state) => {
      state.nearbyLists = [];
    },
    resetNewestLists: (state) => {
      state.newestLists = [];
    },
    resetCollegeLists: (state) => {
      state.collegeLists = [];
    },
    resetPremiumLists: (state) => {
      state.premiumLists = [];
    },
    resetMasqueradePartLists: (state) => {
      state.masqueradePartyLists = [];
    },

    // Pagination Functions
    updateFilteredPage: (state, action) => {
      state.filteredPage = action.payload;
    },
    updateFilteredPagination: (state, action) => {
      state.filteredPagination = action.payload;
    },
    updateRecentlyActivePagination: (state, action) => {
      state.recentlyActivePagination = action.payload;
    },
    updateLgbtqRecentlyActivePagination: (state, action) => {
      state.lgbtqRecentlyActivePagination = action.payload;
    },
    updateNearbyPagination: (state, action) => {
      state.nearbyPagination = action.payload;
    },
    updateNewestPagination: (state, action) => {
      state.newestPagination = action.payload;
    },
    updateCollegePagination: (state, action) => {
      state.collegePagination = action.payload;
    },
    updatePremiumPagination: (state, action) => {
      state.premiumPagination = action.payload;
    },
    updateMasqueradePartyPagination: (state, action) => {
      state.masqueradePartyPagination = action.payload;
    },

    // TOR Functions
    updateTorList: (state, action) => {
      state.torList = action.payload;
    },
    resetTorListSelected: (state) => {
      const torListData = [...state.torList];

      for (let i = 0; i < torListData.length; i++) {
        torListData[i].selected = false;
      }

      state.torList = torListData;
    },
    updateSelectedTorAfterApply: (state, action) => {
      // Used to highlight TOR in user profile if selected in search filter and applying
      state.selectedTorAfterApply = action.payload;
    },
    resetSelectedTorAfterApply: (state) => {
      state.selectedTorAfterApply = [];
    },

    // General Functions
    updateSelectedCategoryTab: (state, action) => {
      state.selectedCategoryTab = action.payload;
      state.searchParam.sort_by = action.payload;
    },
    updateSelectedView: (state, action) => {
      state.selectedView = action.payload;
    },

    // API Param & Body Functions
    updateSearchSortByParam: (state, action) => {
      // state.searchParam.sort_by = action.payload;
    },
    updateSearchPageBody: (state, action) => {
      state.searchBody.page = action.payload;
    },
    updateSearchKeywordBody: (state, action) => {
      state.searchBody.keyword = action.payload;
    },
    updateSearchLocationBody: (state, action) => {
      state.searchBody.location = action.payload;
    },
    updateSearchLocationDataBody: (state, action) => {
      state.searchBody.location_data = action.payload;
    },
    updateSearchMinAgeBody: (state, action) => {
      state.searchBody["min-age"] = action.payload;
    },
    updateSearchMaxAgeBody: (state, action) => {
      state.searchBody["max_age"] = action.payload;
    },
    updateSearchMinHeightBody: (state, action) => {
      state.searchBody["min-height"] = action.payload;
    },
    updateSearchMaxHeightBody: (state, action) => {
      state.searchBody["max-height"] = action.payload;
    },
    updateSearchOptionsBody: (state, action) => {
      state.searchBody.options = action.payload;
    },
    updateSearchLifestyleBody: (state, action) => {
      state.searchBody.lifestyle = action.payload;
    },
    updateSearchBodyTypeBody: (state, action) => {
      state.searchBody.bodytype = action.payload;
    },
    updateSearchEthnicityBody: (state, action) => {
      state.searchBody.ethnicity = action.payload;
    },
    updateSearchEyeColorBody: (state, action) => {
      state.searchBody.eyecolor = action.payload;
    },
    updateSearchHairColorBody: (state, action) => {
      state.searchBody.haircolor = action.payload;
    },
    updateSearchSmokingBody: (state, action) => {
      state.searchBody.smoking = action.payload;
    },
    updateSearchDrinkingBody: (state, action) => {
      state.searchBody.drinking = action.payload;
    },
    updateSearchRelationshipBody: (state, action) => {
      state.searchBody.relationship = action.payload;
    },
    updateSearchEducationBody: (state, action) => {
      state.searchBody.education = action.payload;
    },

    // Scroll Functions
    updateScrollYPosition: (state, action) => {
      state.scrollYPosition = action.payload;
    },
    updateSearchScrollToTopPassthrough: (state, action) => {
      state.searchScrollToTopPassthrough = action.payload;
    },

    // Utility Functions
    resetSearchStore: () => {
      return { ...initialState };
    },
    updateSetCurrentLocationPassthrough: (state) => {
      state.setCurrentLocationPassthrough = {};
    },
    resetSearchBodyFilter: (state) => {
      state.searchBody = {
        size: 16,
        location: {
          lat: null,
          lng: null,
          country: null,
          city: null,
          state: null,
        },
        sorting: "", // nearest, newest, college, featured, recently_active
        filters: {
          search_term: null,
          photos: null,
          viewed: null,
          unviewed: null,
          favorited: null,
          favorited_me: null,
          age: {
            min: searchConst.filters.ageRange.min,
            max: searchConst.filters.ageRange.max,
          },
          // height: {
          //   min: searchConst.filters.heightRange.min,
          //   max: searchConst.filters.heightRange.max,
          // },
          children: null,
          ethnicity: null,
          tor: null,
          lifestyle: null,
          relationship: null,
          body_type: null,
          drinking: null,
          smoking: null,
          education: null,
          eye_color: null,
          hair_color: null,
        },
      };
    },
    composeSearchBody: (state, action) => {
      let searchTerm = null;
      let ethnicity = [];
      let lifestyle = [];
      let relationship = [];
      let bodyType = [];
      let drinking = [];
      let smoking = [];
      let education = [];
      let eyeColor = [];
      let hairColor = [];

      // Keyword | Not working, filter from filtered-view instead
      if (action.payload.keyword && action.payload.keyword !== "") {
        searchTerm = action.payload.keyword;
      }
      state.searchBody.filters.search_term = searchTerm;

      // Location
      const locationObj = {
        lat: action.payload.location.lat,
        lng: action.payload.location.lng,
        country: action.payload.location_data.country,
        country_iso: action.payload.location_data.country_iso,
        city: action.payload.location_data.city,
        state: action.payload.location_data.state,
      };

      if (locationObj.lat && locationObj.lng) {
        state.searchBody.location = locationObj;
      } else {
        state.searchBody.location = {};
      }

      // Premium
      state.searchBody.filters.premium_only = action.payload.premiumOnly;

      // Photos
      state.searchBody.filters.photos = action.payload.photos;

      // Viewed
      state.searchBody.filters.viewed = action.payload.viewed;

      // Unviewed
      state.searchBody.filters.unviewed = action.payload.unviewed;

      // Favorited
      state.searchBody.filters.favorited = action.payload.favorited;

      // Favorited Me
      state.searchBody.filters.favorited_me = action.payload.favoritedMe;

      // Search Term
      state.searchBody.filters.search_term = action.payload.keyword;

      // Age
      state.searchBody.filters.age.min = action.payload.minAge;
      state.searchBody.filters.age.max = action.payload.maxAge;

      // Height | Removed
      // state.searchBody.filters.height.min = action.payload.minHeight;
      // state.searchBody.filters.height.max = action.payload.maxHeight;

      // Children | TBA

      // Ethnicity
      if (action.payload.ethnicity.length > 0) {
        for (let i = 0; i < action.payload.ethnicity.length; i++) {
          if (action.payload.ethnicity[i].isSelected) {
            ethnicity.push(action.payload.ethnicity[i].id);
          }
        }
      }
      state.searchBody.filters.ethnicity =
        ethnicity.length > 0 ? ethnicity : null;

      // TOR
      state.searchBody.filters.tor =
        action.payload.tor.length > 0 ? action.payload.tor : null;

      // Lifestyle
      if (action.payload.lifestyle.length > 0) {
        for (let i = 0; i < action.payload.lifestyle.length; i++) {
          if (action.payload.lifestyle[i].isSelected) {
            lifestyle.push(action.payload.lifestyle[i].id);
          }
        }
      }
      state.searchBody.filters.lifestyle =
        lifestyle.length > 0 ? lifestyle : null;

      // Relationship
      if (action.payload.relationshipStatus.length > 0) {
        for (let i = 0; i < action.payload.relationshipStatus.length; i++) {
          if (action.payload.relationshipStatus[i].isSelected) {
            relationship.push(action.payload.relationshipStatus[i].id);
          }
        }
      }
      state.searchBody.filters.relationship =
        relationship.length > 0 ? relationship : null;

      // Body Type
      if (action.payload.bodyType.length > 0) {
        for (let i = 0; i < action.payload.bodyType.length; i++) {
          if (action.payload.bodyType[i].isSelected) {
            bodyType.push(action.payload.bodyType[i].id);
          }
        }
      }
      state.searchBody.filters.body_type =
        bodyType.length > 0 ? bodyType : null;

      // Drinking
      if (action.payload.drinking.length > 0) {
        for (let i = 0; i < action.payload.drinking.length; i++) {
          if (action.payload.drinking[i].isSelected) {
            drinking.push(action.payload.drinking[i].id);
          }
        }
      }
      state.searchBody.filters.drinking = drinking.length > 0 ? drinking : null;

      // Smoking
      if (action.payload.smoking.length > 0) {
        for (let i = 0; i < action.payload.smoking.length; i++) {
          if (action.payload.smoking[i].isSelected) {
            smoking.push(action.payload.smoking[i].id);
          }
        }
      }
      state.searchBody.filters.smoking = smoking.length > 0 ? smoking : null;

      // Education
      if (action.payload.education.length > 0) {
        for (let i = 0; i < action.payload.education.length; i++) {
          if (action.payload.education[i].isSelected) {
            education.push(action.payload.education[i].id);
          }
        }
      }
      state.searchBody.filters.education =
        education.length > 0 ? education : null;

      // Eye Color
      if (action.payload.eyeColor.length > 0) {
        for (let i = 0; i < action.payload.eyeColor.length; i++) {
          if (action.payload.eyeColor[i].isSelected) {
            eyeColor.push(action.payload.eyeColor[i].id);
          }
        }
      }
      state.searchBody.filters.eye_color =
        eyeColor.length > 0 ? eyeColor : null;

      // Hair Color
      if (action.payload.hairColor.length > 0) {
        for (let i = 0; i < action.payload.hairColor.length; i++) {
          if (action.payload.hairColor[i].isSelected) {
            hairColor.push(action.payload.hairColor[i].id);
          }
        }
      }
      state.searchBody.filters.hair_color =
        hairColor.length > 0 ? hairColor : null;
    },
    updateLocalSearchList: (state, action) => {
      const idInt = action.payload.idInt;
      const privatePhotoRequested = action.payload.privatePhotoRequested;
      const isBlocked = action.payload.isBlocked;
      const isFavorited = action.payload.isFavorited;

      const filteredListsData = [...state.filteredLists];
      const recentlyActiveListsData = [...state.recentlyActiveLists];
      const nearbyListsData = [...state.nearbyLists];
      const newestListsData = [...state.newestLists];
      const collegeListsData = [...state.collegeLists];
      const premiumListsData = [...state.premiumLists];

      // Filtered Lists
      for (let i = 0; i < filteredListsData.length; i++) {
        if (
          filteredListsData[i].user &&
          filteredListsData[i].user.id_int === idInt
        ) {
          if (privatePhotoRequested !== null) {
            filteredListsData[i].user.interaction.private_photo_approval =
              privatePhotoRequested;
          }

          if (isBlocked !== null) {
            filteredListsData[i].user.interaction.is_blocked = isBlocked;
          }

          if (isFavorited !== null) {
            filteredListsData[i].user.interaction.is_favorited = isFavorited;
          }
          break;
        }
      }

      // Recently Active Lists
      for (let i = 0; i < recentlyActiveListsData.length; i++) {
        if (
          recentlyActiveListsData[i].user &&
          recentlyActiveListsData[i].user.id_int === idInt
        ) {
          if (privatePhotoRequested !== null) {
            recentlyActiveListsData[i].user.interaction.private_photo_approval =
              privatePhotoRequested;
          }

          if (isBlocked !== null) {
            recentlyActiveListsData[i].user.interaction.is_blocked = isBlocked;
          }

          if (isFavorited !== null) {
            recentlyActiveListsData[i].user.interaction.is_favorited =
              isFavorited;
          }
          break;
        }
      }

      // Nearby Lists
      for (let i = 0; i < nearbyListsData.length; i++) {
        if (
          nearbyListsData[i].user &&
          nearbyListsData[i].user.id_int === idInt
        ) {
          if (privatePhotoRequested !== null) {
            nearbyListsData[i].user.interaction.private_photo_approval =
              privatePhotoRequested;
          }

          if (isBlocked !== null) {
            nearbyListsData[i].user.interaction.is_blocked = isBlocked;
          }

          if (isFavorited !== null) {
            nearbyListsData[i].user.interaction.is_favorited = isFavorited;
          }
          break;
        }
      }

      // Newest Lists
      for (let i = 0; i < newestListsData.length; i++) {
        if (
          newestListsData[i].user &&
          newestListsData[i].user.id_int === idInt
        ) {
          if (privatePhotoRequested !== null) {
            newestListsData[i].user.interaction.private_photo_approval =
              privatePhotoRequested;
          }

          if (isBlocked !== null) {
            newestListsData[i].user.interaction.is_blocked = isBlocked;
          }

          if (isFavorited !== null) {
            newestListsData[i].user.interaction.is_favorited = isFavorited;
          }
          break;
        }
      }

      // College Lists
      for (let i = 0; i < collegeListsData.length; i++) {
        if (
          collegeListsData[i].user &&
          collegeListsData[i].user.id_int === idInt
        ) {
          if (privatePhotoRequested !== null) {
            collegeListsData[i].user.interaction.private_photo_approval =
              privatePhotoRequested;
          }

          if (isBlocked !== null) {
            collegeListsData[i].user.interaction.is_blocked = isBlocked;
          }

          if (isFavorited !== null) {
            collegeListsData[i].user.interaction.is_favorited = isFavorited;
          }
          break;
        }
      }

      // Premium Lists
      for (let i = 0; i < premiumListsData.length; i++) {
        if (
          premiumListsData[i].user &&
          premiumListsData[i].user.id_int === idInt
        ) {
          if (privatePhotoRequested !== null) {
            premiumListsData[i].user.interaction.private_photo_approval =
              privatePhotoRequested;
          }

          if (isBlocked !== null) {
            premiumListsData[i].user.interaction.is_blocked = isBlocked;
          }

          if (isFavorited !== null) {
            premiumListsData[i].user.interaction.is_favorited = isFavorited;
          }
          break;
        }
      }

      state.filteredLists = filteredListsData;
      state.recentlyActiveLists = recentlyActiveListsData;
      state.nearbyLists = nearbyListsData;
      state.newestLists = newestListsData;
      state.collegeLists = collegeListsData;
      state.premiumLists = premiumListsData;
    },
    updateRestartJourneyCounter: (state) => {
      state.restartJourneyCounter += 1;
    },
    resetRestartJourneyCounter: (state) => {
      state.restartJourneyCounter = 0;
    },
  },
});

export const {
  // Main Page Functions
  updateFilteredLists,
  updateRecentlyActiveLists,
  updateLgbtqRecentlyActiveLists,
  updateNearbyLists,
  updateNewestLists,
  updateCollegeLists,
  updatePremiumLists,
  updateMasqueradePartyLists,
  resetDatingSearchLists,
  resetFilteredLists,
  resetRecentlyActiveLists,
  resetLgbtqRecentlyActiveLists,
  resetNearbyLists,
  resetNewestLists,
  resetCollegeLists,
  resetPremiumLists,
  resetMasqueradePartyLists,

  // Pagination Functions
  updateFilteredPage,
  updateFilteredPagination,
  updateRecentlyActivePagination,
  updateLgbtqRecentlyActivePagination,
  updateNearbyPagination,
  updateNewestPagination,
  updateCollegePagination,
  updatePremiumPagination,
  updateMasqueradePartyPagination,

  // TOR Functions
  updateTorList,
  resetTorListSelected,
  updateSelectedTorAfterApply,
  resetSelectedTorAfterApply,

  // General Functions
  updateSelectedCategoryTab,
  updateSelectedView,

  // API Param & Body Functions
  updateSearchSortByParam,
  updateSearchPageBody,
  updateSearchKeywordBody,
  updateSearchLocationBody,
  updateSearchLocationDataBody,
  updateSearchMinAgeBody,
  updateSearchMaxAgeBody,
  updateSearchMinHeightBody,
  updateSearchMaxHeightBody,
  updateSearchOptionsBody,
  updateSearchLifestyleBody,
  updateSearchBodyTypeBody,
  updateSearchEthnicityBody,
  updateSearchEyeColorBody,
  updateSearchHairColorBody,
  updateSearchSmokingBody,
  updateSearchDrinkingBody,
  updateSearchRelationshipBody,
  updateSearchEducationBody,

  // Scroll Functions
  updateScrollYPosition,
  updateSearchScrollToTopPassthrough,

  // Utility Functions
  resetSearchStore,
  updateSetCurrentLocationPassthrough,
  resetSearchBodyFilter,
  composeSearchBody,
  updateLocalSearchList,
  updateRestartJourneyCounter,
  resetRestartJourneyCounter,
} = searchSlice.actions;

export default searchSlice.reducer;
